var _style, _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "camera-29_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".camera-29_svg__st11{fill:#e30613}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M811.1 264.8c-16.6 0-30.3-12.5-32.3-28.6-.2-1.3-.2-2.6-.2-3.9 0-1.3.1-2.6.2-3.9-.3-9.9-1.9-19.5-4.5-28.6-14.1-49.2-59.5-85.2-113.2-85.2H362.8c-53.6 0-99 36.1-113.2 85.2-2.8 9.8-4.4 20.2-4.5 30.9v3.2c-.8 17.2-15 30.9-32.5 30.9H67.8v644.7h888.3V264.8h-145z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M778.8 236.2c0-1.3.1-2.6.1-3.9s0-2.6-.1-3.9c-.2 1.3-.2 2.6-.2 3.9 0 1.3.1 2.6.2 3.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M988.7 199.8H841c-15.4-85.3-90.2-150.2-179.8-150.2H362.8c-89.7 0-164.5 64.9-179.8 150.2H35.3c-17.9 0-32.5 14.6-32.5 32.5V942c0 17.9 14.6 32.5 32.5 32.5h953.3c17.9 0 32.5-14.6 32.5-32.5V232.3c.1-18-14.5-32.5-32.4-32.5zm-805.7 65h29.7c17.4 0 31.6-13.7 32.5-30.9v-1.6-1.6c.1-10.7 1.7-21.1 4.5-30.9 14.1-49.2 59.5-85.2 113.2-85.2h298.3c53.6 0 99 36.1 113.2 85.2 2.6 9.1 4.2 18.7 4.5 28.6 0 1.3.1 2.6.1 3.9s0 2.6-.1 3.9c1.9 16.1 15.6 28.6 32.3 28.6h145v644.7H67.8V264.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.1 230.7v1.6c.1-.5.1-1.1 0-1.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f9af17",
    d: "M512 323c32.7 0 64.3 6.4 94 19 28.8 12.2 54.6 29.6 76.8 51.8 22.2 22.2 39.6 48.1 51.8 76.8 12.6 29.7 19 61.4 19 94s-6.4 64.3-19 94c-12.2 28.8-29.6 54.6-51.8 76.8-22.2 22.2-48.1 39.6-76.8 51.8-29.7 12.6-61.4 19-94 19s-64.3-6.4-94-19c-28.8-12.2-54.6-29.6-76.8-51.8-22.2-22.2-39.6-48.1-51.8-76.8-12.6-29.7-19-61.4-19-94s6.4-64.3 19-94c12.2-28.8 29.6-54.6 51.8-76.8 22.2-22.2 48.1-39.6 76.8-51.8 29.7-12.6 61.3-19 94-19m0-65c-169.4 0-306.6 137.3-306.6 306.6 0 169.4 137.3 306.6 306.6 306.6S818.6 734 818.6 564.7C818.6 395.3 681.4 258 512 258z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera29);
export default ForwardRef;